import { TextField } from '@mui/material';
import HelperText from '@features/lci-report/components/LciReportFieldInput/HelperText';
import { Controller } from 'react-hook-form';
import { NEWLINE_REGEX } from '../../domain/key-takeaways';

type LciReportFieldInputProps = {
  label: string;
  name: string;
  characterLimit: number;
  bulletPointLimit: number;
  minRows?: number;
  required?: boolean;
  disabled?: boolean;
};

const FIXED_ROWS_QUANTITY = 6;

export const LciReportFieldInput = ({
  label,
  name,
  characterLimit,
  bulletPointLimit,
  minRows,
  required,
  disabled,
}: LciReportFieldInputProps) => {
  return (
    <Controller
      name={name}
      render={({ field }) => {
        const value = field.value as string;

        return (
          <TextField
            {...field}
            value={value ?? ''}
            label={label}
            multiline
            required={required}
            FormHelperTextProps={{
              component: 'div',
            }}
            onChange={e =>
              e.target.value.split(NEWLINE_REGEX).length <= bulletPointLimit &&
              field.onChange(e)
            }
            minRows={minRows ?? FIXED_ROWS_QUANTITY}
            maxRows={FIXED_ROWS_QUANTITY}
            helperText={
              <HelperText
                value={value}
                characterLimit={characterLimit}
                bulletPointLimit={bulletPointLimit}
              />
            }
            inputProps={{ maxLength: characterLimit }}
            disabled={disabled}
          />
        );
      }}
    />
  );
};
